module.exports = __webpack_public_path__ + "static/img/photo_AR.96d306f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo-da/photo_AR.jpg
// module id = cuta
// module chunks = 12